/**
 * Formata a entrada de CPF ou CNPJ conforme o número de dígitos.
 *
 * A função remove caracteres não numéricos do input e, dependendo
 * do número de dígitos, formata o valor como CPF (11 dígitos) ou CNPJ (14 dígitos).
 * Se não atingir o tamanho esperado, exibe o valor sem formatação.
 *
 * @param {Event} event - Evento disparado pelo input.
 * @param {Function} setValueCpf - Função para atualizar o estado do CPF/CNPJ.
 */
export function handleInputChangeCpf(event, setValueCpf) {
    const { value } = event.target;
    console.log("cpf formatação");
    // Remove tudo que não for número
    const newValue = value.replace(/\D/g, "");

    // Verifica se o valor tem 11 dígitos
    if (newValue.length === 11) {
        // Formata o CPF
        const formattedValue = newValue.replace(
            /(\d{3})(\d{3})(\d{3})(\d{2})/,
            "$1.$2.$3-$4"
        );
        setValueCpf(formattedValue);
    } else if (newValue.length === 14) {
        // Formata o CNPJ
        const formattedValue = newValue.replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
            "$1.$2.$3/$4-$5"
        );
        setValueCpf(formattedValue);
    } else {
        // Caso contrário, exibe o valor sem formatação
        setValueCpf(newValue);
    }
}